// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------

import { BrowserType } from '../const';

const userAgentRules: any[] = [
  ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9.]+)(:?\s|$)/],
  ['crios', /CriOS\/([0-9.]+)(:?\s|$)/],
  ['firefox', /Firefox\/([0-9.]+)(?:\s|$)/],
  ['fxios', /FxiOS\/([0-9.]+)/],
  ['android', /Android\s([0-9.]+)/],
  ['ios', /Version\/([0-9._]+).*Mobile.*Safari.*/],
  ['safari', /Version\/([0-9._]+).*Safari/],
  ['facebook', /FB[AS]V\/([0-9.]+)/],
  ['instagram', /Instagram\s([0-9.]+)/],
  ['ios-webview', /AppleWebKit\/([0-9.]+).*Mobile/],
  ['ios-webview', /AppleWebKit\/([0-9.]+).*Gecko\)$/],
  ['curl', /^curl\/([0-9.]+)$/],
];

export const useBrowserDetect = () => {
  const ua = window.navigator.userAgent;

  const matchUserAgent = () => {
    return (
      ua !== '' &&
      userAgentRules.reduce((matched, [browser, regex]) => {
        if (matched) {
          return matched;
        }

        const uaMatch = regex.exec(ua);
        return !!uaMatch && [browser, uaMatch];
      }, false)
    );
  };

  const browserName = () => {
    const data = matchUserAgent();
    return data ? data[0] : '';
  };

  const isSafari = () =>
    browserName().toLowerCase() === BrowserType.SafariMobile ||
    browserName().toLowerCase() === BrowserType.Safari;

  return {
    isSafari,
  };
};
